import styled from 'styled-components'
import { BREAKPOINTS } from 'styles/constants'
import { TextStyle3 } from 'ui/components/typography/TextStyle3'

const AddHeaderStyled = styled.div`
  padding: 32px;
  padding-bottom: 25px;
  display: flex;
  align-content: center;
  justify-content: space-between;
  margin-bottom: ${(p) => (p.marginBottom ? p.marginBottom : 0)};
  position: relative;
`

export const LoadingContainer = styled.div`
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
`

export const AddInner = styled.div`
  padding: 32px;
`

export const AddButtonGroup = styled.div`
  margin-top: auto;

  button {
    &:not(:only-of-type):nth-of-type(1) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    &:not(:only-of-type):nth-of-type(2) {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }

  ${AddInner} {
    display: flex;
    align-items: center;
    padding-top: 16px;
  }
`

export const AddBody = styled.div`
  flex-grow: 1;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    max-height: calc(100vh - 260px);
    overflow: auto;
  }
`

export const AddHeader = (props) => {
  return (
    <AddHeaderStyled {...props}>
      <TextStyle3>{props.title}</TextStyle3>
    </AddHeaderStyled>
  )
}
